module.exports = __webpack_public_path__ + "img/20210728.535b0844.gif";